import { useCallback } from 'react'
import { useLazyQuery, useMutation } from '@apollo/client'

import { useCache } from '~/shared/hooks'
import { QUERY_CHANNELS } from '~/app/state/queries'
import { SET_CHANNELS } from '~/app/state/mutations'

/**
 *
 */
export default function useChannels() {
  const { getData, setData } = useCache()

  const [queryChannels, { data, error, loading, refetch }] =
    useLazyQuery(QUERY_CHANNELS)

  const [mutate] = useMutation(SET_CHANNELS)

  const mutateChannels = useCallback(
    (channels: any) => {
      mutate({ variables: { channels } })
    },
    [mutate],
  )

  const getChannels = useCallback(() => {
    const result = getData({
      query: QUERY_CHANNELS,
    })

    return result ? result.channels : null
  }, [getData])

  const setChannels = useCallback(
    (channels: any) => {
      setData({
        query: QUERY_CHANNELS,
        data: { channels },
      })
    },
    [setData],
  )

  return {
    channels: data ? data.channels : null,
    getChannels,
    setChannels,
    queryChannels,
    queryChannelsStatus: { loading, error, refetch },
    mutateChannels,
  }
}
